import { AppRouter } from "./pages/router.tsx";
import type { FunctionComponent } from "preact";

export const App: FunctionComponent = (_) => {
    return (
        <>
            <AppRouter />
        </>
    );
};
export default App;
